(function () {
  'use strict';

  const $ = id => document.getElementById(id);
  const root = () => $('hrwRoot');
  const cb = id => ($('hrw_' + id) || {}).checked || false;

  const radio = name => {
    const el = document.querySelector(`input[name="hrw_${name}"]:checked`);
    return el ? el.value : '';
  };

  const ALL_ORGANS = [
    'hrwOg-brain',
    'hrwOg-heart',
    'hrwOg-lung-L',
    'hrwOg-lung-R',
    'hrwOg-liver',
    'hrwOg-spleen',
    'hrwOg-aorta'
  ];

  const ORGAN_ID_MAP = {
    brain: 'hrwOg-brain',
    heart: 'hrwOg-heart',
    'lung-L': 'hrwOg-lung-L',
    'lung-R': 'hrwOg-lung-R',
    liver: 'hrwOg-liver',
    spleen: 'hrwOg-spleen',
    aorta: 'hrwOg-aorta'
  };

  let hasRun = false;
  let hasUserInteracted = false;
  let latestScores = null;
  let latestPackageIndex = 0;

  function clamp(value) {
    return Math.min(100, Math.max(0, Math.round(value)));
  }

  function getPackages() {
    return Array.isArray(window.HRW_PACKAGES) ? window.HRW_PACKAGES : [];
  }

  function getPackageByIndex(index) {
    return getPackages().find(packageRule => Number(packageRule.index) === Number(index));
  }

  function normalizeList(value) {
    if (Array.isArray(value)) return value.filter(Boolean);

    if (typeof value === 'string' && value.trim() !== '') {
      return value
        .split(',')
        .map(item => item.trim())
        .filter(Boolean);
    }

    return [];
  }

  function computeScores() {
    const age = +($('hrw_age') || {}).value || 45;
    const sex = ($('hrw_sex') || {}).value || 'male';
    const bmi = ($('hrw_bmi') || {}).value || '';
    const eth = ($('hrw_ethnicity') || {}).value || '';

    const smoke = radio('smoke') || 'never';
    const activity = radio('activity') || 'moderate';
    const alcohol = radio('alcohol') || 'none';
    const diet = radio('diet') || 'average';
    const sleep = radio('sleep') || 'normal';
    const stress = radio('stress') || 'low';

    const ageFactor = Math.max(0, (age - 25) / 65);

    let cardiac = 0;
    let oncology = 0;
    let neuro = 0;
    let metabolic = 0;
    let pulmonary = 0;
    let mental = 0;

    cardiac += ageFactor * 22;
    oncology += ageFactor * 18;
    neuro += ageFactor * 16;
    metabolic += ageFactor * 14;

    if (sex === 'male') {
      cardiac += 4;
      oncology += 3;
    }

    if (eth === 'black') cardiac += 6;
    if (eth === 'hispanic') metabolic += 5;

    if (bmi === 'over') {
      cardiac += 6;
      metabolic += 8;
      oncology += 4;
    }

    if (bmi === 'obese1') {
      cardiac += 12;
      metabolic += 16;
      oncology += 8;
      pulmonary += 6;
    }

    if (bmi === 'obese2') {
      cardiac += 18;
      metabolic += 22;
      oncology += 12;
      pulmonary += 10;
      neuro += 5;
    }

    if (cb('fh_heart')) cardiac += 18;

    if (cb('fh_stroke')) {
      cardiac += 12;
      neuro += 10;
    }

    if (cb('fh_hbp')) cardiac += 10;
    if (cb('fh_cholesterol')) cardiac += 10;

    if (cb('fh_afib')) {
      cardiac += 10;
      neuro += 6;
    }

    if (cb('fh_aortic')) cardiac += 12;

    if (cb('fh_colon')) oncology += 18;
    if (cb('fh_breast')) oncology += 16;
    if (cb('fh_prostate')) oncology += 14;

    if (cb('fh_lung_c')) {
      oncology += 15;
      pulmonary += 8;
    }

    if (cb('fh_skin')) oncology += 10;

    if (cb('fh_brain')) {
      oncology += 12;
      neuro += 14;
    }

    if (cb('fh_diabetes')) metabolic += 16;
    if (cb('fh_alzheimer')) neuro += 18;
    if (cb('fh_kidney')) metabolic += 10;
    if (cb('fh_liver')) metabolic += 12;
    if (cb('fh_osteo')) metabolic += 6;

    if (cb('fh_autoimmune')) {
      oncology += 8;
      metabolic += 6;
    }

    if (cb('ph_hbp')) cardiac += 16;
    if (cb('ph_chol')) cardiac += 12;

    if (cb('ph_diab')) {
      metabolic += 18;
      cardiac += 8;
    }

    if (cb('ph_heart')) cardiac += 22;

    if (cb('ph_stroke')) {
      neuro += 20;
      cardiac += 10;
    }

    if (cb('ph_copd')) {
      pulmonary += 22;
      cardiac += 8;
    }

    if (cb('ph_kidney')) {
      metabolic += 16;
      cardiac += 8;
    }

    if (cb('ph_liver')) {
      metabolic += 18;
      oncology += 10;
    }

    if (cb('ph_thyroid')) metabolic += 8;
    if (cb('ph_cancer')) oncology += 24;

    if (cb('ph_afib')) {
      cardiac += 10;
      neuro += 6;
    }

    if (cb('ph_sleep_apnea')) {
      cardiac += 14;
      metabolic += 8;
      neuro += 6;
    }

    if (smoke === 'current') {
      cardiac += 18;
      pulmonary += 24;
      oncology += 18;
    }

    if (smoke === 'former') {
      cardiac += 8;
      pulmonary += 12;
      oncology += 9;
    }

    if (activity === 'sedentary') {
      cardiac += 14;
      metabolic += 12;
      mental += 8;
    }

    if (activity === 'light') {
      cardiac += 6;
      metabolic += 5;
    }

    if (activity === 'active') {
      cardiac -= 6;
      metabolic -= 5;
      neuro -= 4;
      mental -= 6;
    }

    if (alcohol === 'moderate') {
      metabolic += 8;
      cardiac += 6;
    }

    if (alcohol === 'heavy') {
      metabolic += 16;
      cardiac += 12;
      oncology += 12;
      neuro += 8;
      mental += 10;
    }

    if (cb('ls_vaping')) {
      pulmonary += 14;
      cardiac += 6;
    }

    if (cb('ls_drugs')) {
      neuro += 12;
      cardiac += 6;
      mental += 12;
    }

    if (diet === 'poor') {
      cardiac += 10;
      metabolic += 12;
      oncology += 8;
    }

    if (diet === 'good') {
      cardiac -= 3;
      metabolic -= 4;
    }

    if (diet === 'excellent') {
      cardiac -= 6;
      metabolic -= 8;
      oncology -= 4;
    }

    if (cb('diet_processed')) {
      metabolic += 8;
      cardiac += 6;
      oncology += 5;
    }

    if (cb('diet_sugar')) {
      metabolic += 10;
      cardiac += 6;
    }

    if (cb('diet_red_meat')) {
      cardiac += 6;
      oncology += 8;
    }

    if (cb('diet_veg')) {
      oncology += 6;
      metabolic += 5;
    }

    if (sleep === 'very_short') {
      cardiac += 10;
      neuro += 12;
      mental += 14;
      metabolic += 8;
    }

    if (sleep === 'short') {
      cardiac += 5;
      neuro += 6;
      mental += 8;
      metabolic += 4;
    }

    if (sleep === 'long') {
      metabolic += 5;
      mental += 4;
    }

    if (cb('sleep_apnea')) {
      cardiac += 14;
      metabolic += 8;
      neuro += 6;
    }

    if (cb('sleep_insomnia')) {
      mental += 12;
      cardiac += 6;
      neuro += 8;
    }

    if (stress === 'moderate') {
      cardiac += 6;
      mental += 8;
    }

    if (stress === 'high') {
      cardiac += 12;
      mental += 14;
      neuro += 6;
    }

    if (stress === 'severe') {
      cardiac += 18;
      mental += 20;
      neuro += 10;
      metabolic += 8;
    }

    if (cb('mh_depression')) {
      cardiac += 8;
      mental += 14;
    }

    if (cb('mh_anxiety')) {
      cardiac += 6;
      mental += 12;
    }

    if (cb('mh_ptsd')) {
      cardiac += 8;
      mental += 14;
      neuro += 6;
    }

    if (cb('mh_isolation')) {
      cardiac += 6;
      mental += 10;
      neuro += 5;
    }

    if (cb('sx_chest')) {
      cardiac += 22;
      pulmonary += 10;
    }

    if (cb('sx_breath')) {
      pulmonary += 18;
      cardiac += 12;
    }

    if (cb('sx_fatigue')) {
      cardiac += 8;
      metabolic += 8;
      mental += 6;
    }

    if (cb('sx_bloat')) {
      oncology += 14;
      metabolic += 10;
    }

    if (cb('sx_blood')) oncology += 22;

    if (cb('sx_headache')) {
      neuro += 12;
      cardiac += 6;
    }

    if (cb('sx_weight')) {
      oncology += 20;
      metabolic += 8;
    }

    if (cb('sx_swallow')) oncology += 16;

    if (cb('sx_cough')) {
      pulmonary += 16;
      oncology += 8;
    }

    if (cb('sx_memory')) neuro += 20;

    if (cb('env_chemicals')) {
      oncology += 12;
      pulmonary += 8;
    }

    if (cb('env_radiation')) oncology += 14;

    if (cb('env_pollution')) {
      pulmonary += 12;
      cardiac += 8;
    }

    if (cb('env_sedentary_job')) {
      cardiac += 8;
      metabolic += 6;
    }

    return {
      cardiac: clamp(cardiac),
      oncology: clamp(oncology),
      neuro: clamp(neuro),
      metabolic: clamp(metabolic),
      pulmonary: clamp(pulmonary),
      mental: clamp(mental),
      overall: clamp(
        cardiac * 0.25 +
          oncology * 0.22 +
          neuro * 0.15 +
          metabolic * 0.18 +
          pulmonary * 0.12 +
          mental * 0.08
      )
    };
  }

  function logScores(label, scores) {
    console.log(label, scores);
    console.table({
      cardiac: scores.cardiac,
      oncology: scores.oncology,
      neuro: scores.neuro,
      metabolic: scores.metabolic,
      pulmonary: scores.pulmonary,
      mental: scores.mental,
      overall: scores.overall
    });
  }

  function hasTrigger(packageRule) {
    const triggers = normalizeList(packageRule.triggers);

    if (!triggers.length) return false;

    return triggers.some(trigger => cb(trigger));
  }

  function packageMatchesScores(packageRule, scores) {
    const minOverall = Number(packageRule.minOverall || 0);
    const maxOverall = Number(packageRule.maxOverall || 100);

    if (scores.overall < minOverall || scores.overall > maxOverall) return false;
    if (scores.cardiac < Number(packageRule.minCardiac || 0)) return false;
    if (scores.oncology < Number(packageRule.minOncology || 0)) return false;
    if (scores.neuro < Number(packageRule.minNeuro || 0)) return false;
    if (scores.metabolic < Number(packageRule.minMetabolic || 0)) return false;
    if (scores.pulmonary < Number(packageRule.minPulmonary || 0)) return false;
    if (scores.mental < Number(packageRule.minMental || 0)) return false;

    return true;
  }

  function recommend(scores) {
    const packages = getPackages();

    if (!packages.length) return 0;

    const elitePackage = packages.find(packageRule => {
      const title = String(packageRule.title || packageRule.productTitle || '').toLowerCase();

      return title.includes('elite');
    });

    if (elitePackage) {
      const eliteMinOverall = Number(elitePackage.minOverall || 0);
      const eliteMaxOverall = Number(elitePackage.maxOverall || 100);

      if (scores.overall > eliteMinOverall && scores.overall <= eliteMaxOverall) {
        return Number(elitePackage.index || 0);
      }
    }

    const triggerMatch = packages.find(packageRule => hasTrigger(packageRule));

    if (triggerMatch) return Number(triggerMatch.index || 0);

    const scoreMatch = packages.find(packageRule => packageMatchesScores(packageRule, scores));

    if (scoreMatch) return Number(scoreMatch.index || 0);

    const fallback = packages.find(packageRule => packageRule.isDefault);

    return fallback ? Number(fallback.index || 0) : 0;
  }

  function getOrgansForPackage(index) {
    const packageRule = getPackageByIndex(index);

    if (!packageRule) return [];

    return normalizeList(packageRule.organs)
      .map(organ => ORGAN_ID_MAP[organ])
      .filter(Boolean);
  }

  function contextOrgans(scores, packageIndex) {
    const list = [...getOrgansForPackage(packageIndex)];

    const add = id => {
      if (!list.includes(id)) list.push(id);
    };

    if (scores.cardiac >= 30 || cb('ph_heart') || cb('fh_heart') || cb('sx_chest')) {
      add('hrwOg-heart');
    }

    if (cb('fh_aortic')) {
      add('hrwOg-aorta');
    }

    if (scores.neuro >= 28 || cb('fh_brain') || cb('fh_alzheimer') || cb('sx_memory')) {
      add('hrwOg-brain');
    }

    if (scores.pulmonary >= 28 || cb('ph_copd') || cb('sx_breath') || cb('sx_cough')) {
      add('hrwOg-lung-L');
      add('hrwOg-lung-R');
    }

    if (scores.metabolic >= 28 || cb('fh_liver') || cb('ph_liver') || cb('fh_diabetes')) {
      add('hrwOg-liver');
      add('hrwOg-spleen');
    }

    if (scores.oncology >= 28 || cb('sx_blood') || cb('fh_colon') || cb('fh_breast')) {
      add('hrwOg-liver');
      add('hrwOg-spleen');
    }

    return list;
  }

  function setOrgans(list) {
    ALL_ORGANS.forEach(id => {
      const el = $(id);

      if (el) {
        el.classList.toggle('lit', list.includes(id));
      }
    });
  }

  function updateBadges(scores) {
    const map = {
      'hrwB-cardiac': scores.cardiac,
      'hrwB-oncology': scores.oncology,
      'hrwB-neuro': scores.neuro,
      'hrwB-metabolic': scores.metabolic,
      'hrwB-pulmonary': scores.pulmonary,
      'hrwB-mental': scores.mental
    };

    Object.entries(map).forEach(([id, value]) => {
      const el = $(id);

      if (el) {
        el.classList.toggle('show', value >= 28);
      }
    });
  }

  function getRiskProfileSummary(scores) {
    const riskSystems = [
      { label: 'cardiac', score: scores.cardiac },
      { label: 'oncology', score: scores.oncology },
      { label: 'neuro', score: scores.neuro },
      { label: 'metabolic', score: scores.metabolic },
      { label: 'pulmonary', score: scores.pulmonary },
      { label: 'mental', score: scores.mental }
    ];

    const elevatedSystems = riskSystems
      .filter(system => Number(system.score) >= 28)
      .map(system => `${system.label} (${system.score})`);

    return elevatedSystems.length ? elevatedSystems.join(', ') : 'None';
  }

  function getEnteredAge() {
    const ageInput = $('hrw_age');

    if (!ageInput || ageInput.value === '') return '';

    return String(ageInput.value);
  }

  function getCartProperties(scores) {
    return {
      riskProfile: getRiskProfileSummary(scores),
      overallRiskScore: `${scores.overall}/100`,
      age: getEnteredAge(),
      source: 'Health Risk Assessment'
    };
  }

  function getCheckboxGroups() {
    const widgetRoot = root();

    if (!widgetRoot) return [];

    const groups = new Set();

    widgetRoot.querySelectorAll('[data-hrw-checkbox-group]').forEach(group => {
      groups.add(group);
    });

    widgetRoot.querySelectorAll('.cg').forEach(group => {
      const checkboxes = group.querySelectorAll('input[type="checkbox"][id^="hrw_"]');

      if (checkboxes.length > 1) {
        groups.add(group);
      }
    });

    return Array.from(groups);
  }

  function getCheckboxGroup(input) {
    if (!input || input.type !== 'checkbox') return null;

    const explicitGroup = input.closest('[data-hrw-checkbox-group]');

    if (explicitGroup) return explicitGroup;

    const fallbackGroup = input.closest('.cg');

    if (!fallbackGroup) return null;

    const checkboxes = fallbackGroup.querySelectorAll('input[type="checkbox"][id^="hrw_"]');

    return checkboxes.length > 1 ? fallbackGroup : null;
  }

  function isNoneCheckbox(input) {
    if (!input) return false;

    const id = String(input.id || '').replace(/^hrw_/, '').toLowerCase();
    const value = String(input.value || '').toLowerCase();

    return (
      input.hasAttribute('data-hrw-none-option') ||
      id === 'none' ||
      id.endsWith('_none') ||
      value === 'none'
    );
  }

  function getCheckboxGroupKey(group, index) {
    if (group.dataset.hrwCheckboxGroup) {
      return group.dataset.hrwCheckboxGroup;
    }

    const firstCheckbox = group.querySelector('input[type="checkbox"][id^="hrw_"]');
    const fallbackKey = firstCheckbox
      ? firstCheckbox.id.replace(/^hrw_/, '').split('_')[0]
      : `group_${index}`;

    const key = `auto_${fallbackKey}_${index}`;

    group.dataset.hrwCheckboxGroup = key;

    return key;
  }

  function createNoneCheckbox(group, groupKey) {
    const firstLabel = group.querySelector('label');
    const firstCheckmark = group.querySelector('.cm');

    const label = document.createElement('label');
    const input = document.createElement('input');
    const checkmark = document.createElement('span');
    const text = document.createElement('span');

    label.className = firstLabel ? `${firstLabel.className} hrw-none-option` : 'ci hrw-none-option';

    input.type = 'checkbox';
    input.id = `hrw_${groupKey}_none`;
    input.value = 'none';
    input.setAttribute('data-hrw-none-option', '');

    checkmark.className = firstCheckmark ? firstCheckmark.className : 'cm';
    checkmark.innerHTML = firstCheckmark ? firstCheckmark.innerHTML : '';

    text.textContent = window.HRW_LABELS?.noneLabel || 'None';

    label.appendChild(input);
    label.appendChild(checkmark);
    label.appendChild(text);

    group.prepend(label);
  }

  function ensureNoneOptions() {
    getCheckboxGroups().forEach((group, index) => {
      const checkboxes = Array.from(group.querySelectorAll('input[type="checkbox"][id^="hrw_"]'));

      if (!checkboxes.length) return;

      const hasNoneCheckbox = checkboxes.some(isNoneCheckbox);

      if (hasNoneCheckbox) return;

      const groupKey = getCheckboxGroupKey(group, index);

      createNoneCheckbox(group, groupKey);
    });
  }

  function setCheckboxDisabledState(checkbox, isDisabled) {
    checkbox.disabled = isDisabled;

    const label = checkbox.closest('label');

    if (label) {
      label.classList.toggle('is-disabled', isDisabled);
      label.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');
    }
  }

  function syncExclusiveNoneCheckboxGroup(group) {
    if (!group) return;

    const checkboxes = Array.from(group.querySelectorAll('input[type="checkbox"][id^="hrw_"]'));
    const noneCheckbox = checkboxes.find(isNoneCheckbox);

    if (!noneCheckbox) return;

    const hasRealSelection = checkboxes.some(checkbox => checkbox !== noneCheckbox && checkbox.checked);

    if (hasRealSelection && noneCheckbox.checked) {
      noneCheckbox.checked = false;
    }

    const shouldLockOthers = noneCheckbox.checked;

    checkboxes.forEach(checkbox => {
      if (checkbox === noneCheckbox) return;

      if (shouldLockOthers) {
        checkbox.checked = false;
      }

      setCheckboxDisabledState(checkbox, shouldLockOthers);
    });
  }

  function handleExclusiveNoneSelection(input) {
    if (!input || input.type !== 'checkbox') return;

    const group = getCheckboxGroup(input);

    if (!group) return;

    const checkboxes = Array.from(group.querySelectorAll('input[type="checkbox"][id^="hrw_"]'));
    const noneCheckbox = checkboxes.find(isNoneCheckbox);

    if (!noneCheckbox) return;

    if (input === noneCheckbox && noneCheckbox.checked) {
      checkboxes.forEach(checkbox => {
        if (checkbox === noneCheckbox) return;

        checkbox.checked = false;
        checkbox.dataset.hrwTouched = 'true';
      });
    }

    if (input !== noneCheckbox && input.checked) {
      noneCheckbox.checked = false;
      noneCheckbox.dataset.hrwTouched = 'true';
    }

    syncExclusiveNoneCheckboxGroup(group);
  }

  function syncAllExclusiveNoneGroups() {
    getCheckboxGroups().forEach(group => {
      syncExclusiveNoneCheckboxGroup(group);
    });
  }

  function markFieldAsTouched(input) {
    if (!input) return;

    if (input.type === 'radio') {
      const widgetRoot = root();

      if (!widgetRoot) return;

      const escapedName = window.CSS && CSS.escape ? CSS.escape(input.name) : input.name;

      widgetRoot
        .querySelectorAll(`input[type="radio"][name="${escapedName}"]`)
        .forEach(radioInput => {
          radioInput.dataset.hrwTouched = 'true';
        });

      return;
    }

    if (input.type === 'checkbox') {
      const group = getCheckboxGroup(input);

      if (group) {
        group.querySelectorAll('input[type="checkbox"][id^="hrw_"]').forEach(checkbox => {
          checkbox.dataset.hrwTouched = 'true';
        });

        return;
      }
    }

    input.dataset.hrwTouched = 'true';
  }

  function isCompletionAvailableInput(input) {
    if (!input) return false;
    if (input.disabled && !input.checked) return false;

    return true;
  }

  function isCompletionAvailableGroup(group) {
    if (!group) return false;

    const checkboxes = Array.from(
      group.querySelectorAll('input[type="checkbox"][id^="hrw_"]')
    ).filter(isCompletionAvailableInput);

    return checkboxes.length > 0;
  }

  function isCompletionCheckboxGroupComplete(group) {
    const checkboxes = Array.from(
      group.querySelectorAll('input[type="checkbox"][id^="hrw_"]')
    ).filter(isCompletionAvailableInput);

    if (!checkboxes.length) return false;

    return checkboxes.some(checkbox => checkbox.checked);
  }

  function getProfileCompletion() {
    const widgetRoot = root();

    if (!widgetRoot) {
      return {
        completed: 0,
        total: 0,
        percent: 0
      };
    }

    let completed = 0;
    let total = 0;

    const groupedCheckboxes = new Set();

    widgetRoot.querySelectorAll('select[id^="hrw_"]').forEach(select => {
      if (!isCompletionAvailableInput(select)) return;

      const hasRealOptions = Array.from(select.options).some(option => option.value !== '');

      if (!hasRealOptions) return;

      total += 1;

      if (select.dataset.hrwTouched === 'true' && select.value !== '') {
        completed += 1;
      }
    });

    getCheckboxGroups().forEach(group => {
      if (!isCompletionAvailableGroup(group)) return;

      const checkboxes = Array.from(group.querySelectorAll('input[type="checkbox"][id^="hrw_"]'));

      if (!checkboxes.length) return;

      checkboxes.forEach(checkbox => groupedCheckboxes.add(checkbox));

      total += 1;

      const isTouched = checkboxes.some(checkbox => checkbox.dataset.hrwTouched === 'true');

      if (isTouched && isCompletionCheckboxGroupComplete(group)) {
        completed += 1;
      }
    });

    widgetRoot.querySelectorAll('input[type="checkbox"][id^="hrw_"]').forEach(checkbox => {
      if (groupedCheckboxes.has(checkbox)) return;
      if (!isCompletionAvailableInput(checkbox)) return;

      total += 1;

      if (checkbox.dataset.hrwTouched === 'true' && checkbox.checked) {
        completed += 1;
      }
    });

    const radioNames = new Set();

    widgetRoot.querySelectorAll('input[type="radio"][name^="hrw_"]').forEach(radioInput => {
      if (!isCompletionAvailableInput(radioInput)) return;

      radioNames.add(radioInput.name);
    });

    radioNames.forEach(name => {
      const escapedName = window.CSS && CSS.escape ? CSS.escape(name) : name;

      const radios = Array.from(
        widgetRoot.querySelectorAll(`input[type="radio"][name="${escapedName}"]`)
      ).filter(isCompletionAvailableInput);

      if (!radios.length) return;

      total += 1;

      const isTouched = radios.some(radioInput => radioInput.dataset.hrwTouched === 'true');
      const isChecked = radios.some(radioInput => radioInput.checked);

      if (isTouched && isChecked) {
        completed += 1;
      }
    });

    const percent = total > 0 ? Math.round((completed / total) * 100) : 0;

    return {
      completed,
      total,
      percent: Math.min(100, percent)
    };
  }

  function updateProfileCompletion() {
    const completion = getProfileCompletion();
    const valueEl = $('hrwProfileCompletionValue');
    const barEl = $('hrwProfileCompletionBar');

    if (valueEl) valueEl.textContent = `${completion.percent}%`;
    if (barEl) barEl.style.width = `${completion.percent}%`;

    return completion;
  }

  function updateCartPropertyInputs(activeIndex, scores) {
    const properties = getCartProperties(scores);

    document.querySelectorAll('[data-hrw-rec-bar]').forEach(bar => {
      const isActive = Number(bar.dataset.packageIndex) === Number(activeIndex);

      const riskProfileInput = bar.querySelector('[data-hrw-property-risk-profile]');
      const overallRiskScoreInput = bar.querySelector('[data-hrw-property-overall-risk-score]');
      const ageInput = bar.querySelector('[data-hrw-property-age]');
      const sourceInput = bar.querySelector('[data-hrw-property-source]');

      if (riskProfileInput) riskProfileInput.value = isActive ? properties.riskProfile : '';
      if (overallRiskScoreInput) overallRiskScoreInput.value = isActive ? properties.overallRiskScore : '';
      if (ageInput) ageInput.value = isActive ? properties.age : '';
      if (sourceInput) sourceInput.value = isActive ? properties.source : 'Health Risk Assessment';
    });
  }

  function clearCartPropertyInputs() {
    document.querySelectorAll('[data-hrw-rec-bar]').forEach(bar => {
      const riskProfileInput = bar.querySelector('[data-hrw-property-risk-profile]');
      const overallRiskScoreInput = bar.querySelector('[data-hrw-property-overall-risk-score]');
      const ageInput = bar.querySelector('[data-hrw-property-age]');
      const sourceInput = bar.querySelector('[data-hrw-property-source]');

      if (riskProfileInput) riskProfileInput.value = '';
      if (overallRiskScoreInput) overallRiskScoreInput.value = '';
      if (ageInput) ageInput.value = '';
      if (sourceInput) sourceInput.value = 'Health Risk Assessment';
    });
  }

  function ensureCartPropertiesBeforeSubmit(form) {
    if (!form || !latestScores) return;

    const recBar = form.closest('[data-hrw-rec-bar]');

    if (!recBar) return;

    const packageIndex = Number(recBar.dataset.packageIndex || latestPackageIndex);

    updateCartPropertyInputs(packageIndex, latestScores);
  }

  function toggleRecommendationActions(activeIndex, hasRecommendation) {
    document.querySelectorAll('[data-hrw-rec-bar]').forEach(bar => {
      const isActive = Number(bar.dataset.packageIndex) === Number(activeIndex);

      const viewButton = bar.querySelector('[data-hrw-view-details]');
      const atcButton = bar.querySelector('[data-hrw-atc-button]');
      const variantInput = bar.querySelector('.product-variant-id');

      const variantAvailable = variantInput && !variantInput.disabled;
      const shouldEnableView = isActive && hasRecommendation;
      const shouldEnableAtc = shouldEnableView && variantAvailable;

      if (viewButton) {
        viewButton.classList.toggle('is-disabled', !shouldEnableView);
        viewButton.setAttribute('aria-disabled', shouldEnableView ? 'false' : 'true');

        if (shouldEnableView) {
          viewButton.removeAttribute('tabindex');
        } else {
          viewButton.setAttribute('tabindex', '-1');
        }
      }

      if (atcButton) {
        atcButton.disabled = !shouldEnableAtc;
        atcButton.classList.toggle('is-disabled', !shouldEnableAtc);
        atcButton.setAttribute('aria-disabled', shouldEnableAtc ? 'false' : 'true');
      }
    });
  }

  function selectPackage(packageIndex, isAuto) {
    const index = Number(packageIndex);
    const hasRecommendation = Boolean(isAuto || hasRun);

    latestPackageIndex = index;

    document.querySelectorAll('[data-hrw-package-button]').forEach(button => {
      const isActive = Number(button.dataset.packageIndex) === index;

      button.classList.toggle('active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');

      const badge = button.querySelector('.hrw-rec-badge, .rec-badge');

      if (badge) badge.remove();

      if (isActive && isAuto) {
        const packageRule = getPackageByIndex(index);
        const recBadge = document.createElement('div');

        recBadge.className = 'hrw-rec-badge rec-badge';
        recBadge.textContent = packageRule && packageRule.badge ? packageRule.badge : 'Recommended!';
        button.appendChild(recBadge);
      }
    });

    document.querySelectorAll('[data-hrw-rec-bar]').forEach(bar => {
      bar.classList.toggle('is-hidden', Number(bar.dataset.packageIndex) !== index);
    });

    toggleRecommendationActions(index, hasRecommendation);

    if (latestScores) {
      updateCartPropertyInputs(index, latestScores);
    } else {
      clearCartPropertyInputs();
    }

    if (!isAuto && !latestScores) {
      setOrgans(getOrgansForPackage(index));
    }
  }

  function updateRiskMeter(scores) {
    const needle = $('hrwNeedle');

    if (needle) {
      needle.style.left = Math.min(96, Math.max(4, scores.overall)) + '%';
    }

    const chip = $('hrwRiskChip');

    if (!chip) return;

    const labels = window.HRW_LABELS || {};

    if (scores.overall < 22) {
      chip.textContent = labels.riskLow || 'Low';
      chip.style.cssText = 'background:#e6f9ee;color:#0a7a3a;';
      return;
    }

    if (scores.overall < 42) {
      chip.textContent = labels.riskModerate || 'Moderate';
      chip.style.cssText = 'background:#fef9e6;color:#8a5500;';
      return;
    }

    if (scores.overall < 62) {
      chip.textContent = labels.riskElevated || 'Elevated';
      chip.style.cssText = 'background:#fff3e6;color:#9a3412;';
      return;
    }

    chip.textContent = labels.riskHigh || 'High';
    chip.style.cssText = 'background:#fde8ec;color:#991b1b;';
  }

  function reactToCurrentInputs(selectedPackageIndex) {
    const scores = computeScores();
    const packageIndex =
      typeof selectedPackageIndex === 'number'
        ? selectedPackageIndex
        : recommend(scores);

    hasRun = true;
    latestScores = scores;
    latestPackageIndex = packageIndex;

    updateProfileCompletion();
    updateRiskMeter(scores);
    setOrgans(contextOrgans(scores, packageIndex));
    updateBadges(scores);
    selectPackage(packageIndex, selectedPackageIndex === undefined);
    updateCartPropertyInputs(packageIndex, scores);

    logScores('Health Risk Scores:', scores);

    return {
      scores,
      packageIndex
    };
  }

  async function runAnalysis(instant) {
    const loadingEl = $('hrwLoading');

    if (loadingEl) loadingEl.classList.add('show');

    await new Promise(resolve => setTimeout(resolve, instant ? 250 : 1000));

    const result = reactToCurrentInputs();

    if (loadingEl) loadingEl.classList.remove('show');

    return result;
  }

  function submitPackageFormAndRedirect(packageIndex) {
    const recBar = document.querySelector(
      `[data-hrw-rec-bar][data-package-index="${Number(packageIndex)}"]`
    );

    return;

    if (!recBar) {
      window.location.href = '/cart';
      return;
    }

    const form = recBar.querySelector('form[action*="/cart/add"]');

    if (!form) {
      window.location.href = '/cart';
      return;
    }

    const scores = latestScores || computeScores();

    latestScores = scores;
    latestPackageIndex = Number(packageIndex);

    updateCartPropertyInputs(packageIndex, scores);
    ensureCartPropertiesBeforeSubmit(form);

    let returnToInput = form.querySelector('input[name="return_to"]');

    if (!returnToInput) {
      returnToInput = document.createElement('input');
      returnToInput.type = 'hidden';
      returnToInput.name = 'return_to';
      form.appendChild(returnToInput);
    }

    returnToInput.value = '/cart';

    const variantInput = form.querySelector('input[name="id"]');

    if (variantInput) {
      variantInput.disabled = false;
    }

    form.setAttribute('method', 'post');
    form.setAttribute('action', '/cart/add');

    HTMLFormElement.prototype.submit.call(form);
  }

  function onInputChange(event) {
    hasUserInteracted = true;

    const input = event && event.target ? event.target : null;

    if (input) {
      handleExclusiveNoneSelection(input);
      markFieldAsTouched(input);
    }

    syncAllExclusiveNoneGroups();
    updateProfileCompletion();

    reactToCurrentInputs();
  }

  function bindPaneNavigation() {
    const widgetRoot = root();

    if (!widgetRoot) return;

    const introPane = $('hrwPaneIntro');
    const lifestylePane = $('hrwPaneLifestyle');
    const familyPane = $('hrwPaneFamily');
    const titleBar = $('hrwCenterTitlebar');
    const titleText = $('hrwCenterTitleText');
    const openButtons = widgetRoot.querySelectorAll('[data-hrw-open-pane]');
    const closeButton = widgetRoot.querySelector('[data-hrw-close-pane]');

    const isMobileView = () => window.matchMedia('(max-width: 989px)').matches;

    const getStickyHeaderOffset = () => {
      const stickyHeader =
        document.querySelector('sticky-header') ||
        document.querySelector('.shopify-section-header-sticky') ||
        document.querySelector('.header-wrapper') ||
        document.querySelector('#shopify-section-header');

      if (!stickyHeader) return 90;

      const rect = stickyHeader.getBoundingClientRect();

      if (rect.height <= 0) return 90;

      return rect.height + 18;
    };

    const scrollToPane = paneName => {
      if (!isMobileView()) return;

      const target =
        paneName === 'lifestyle'
          ? lifestylePane
          : paneName === 'family'
            ? familyPane
            : introPane;

      const scrollTarget = titleBar && !titleBar.hidden ? titleBar : target;

      if (!scrollTarget) return;

      window.requestAnimationFrame(() => {
        const headerOffset = getStickyHeaderOffset();
        const targetTop =
          scrollTarget.getBoundingClientRect().top + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: Math.max(0, targetTop),
          behavior: 'smooth'
        });
      });
    };

    const setPane = paneName => {
      const isLifestyle = paneName === 'lifestyle';
      const isFamily = paneName === 'family';

      if (introPane) introPane.hidden = isLifestyle || isFamily;
      if (lifestylePane) lifestylePane.hidden = !isLifestyle;
      if (familyPane) familyPane.hidden = !isFamily;
      if (titleBar) titleBar.hidden = !(isLifestyle || isFamily);

      if (titleText) {
        if (isLifestyle) {
          titleText.textContent =
            titleBar?.dataset.lifestyleTitle ||
            window.HRW_LABELS?.lifestyleTitle ||
            'Lifestyle & Symptoms';
        } else if (isFamily) {
          titleText.textContent =
            titleBar?.dataset.familyTitle ||
            window.HRW_LABELS?.familyTitle ||
            'Family History';
        } else {
          titleText.textContent = '';
        }
      }

      openButtons.forEach(button => {
        const isActive = button.dataset.hrwOpenPane === paneName;

        button.classList.toggle('on', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');

        const icon = button.querySelector('[data-hrw-pane-icon]');

        if (icon) {
          icon.textContent = isActive ? '✓' : '+';
        }
      });
    };

    openButtons.forEach(button => {
      button.setAttribute('type', 'button');
      button.setAttribute('aria-pressed', button.classList.contains('on') ? 'true' : 'false');

      button.addEventListener('click', () => {
        const paneName = button.dataset.hrwOpenPane;
        const isActive = button.classList.contains('on');

        if (isActive) {
          setPane('');
          scrollToPane('');
          return;
        }

        setPane(paneName);
        scrollToPane(paneName);
      });
    });

    if (closeButton) {
      closeButton.setAttribute('type', 'button');

      closeButton.addEventListener('click', () => {
        setPane('');
        scrollToPane('');
      });
    }

    setPane('');
  }

  function bindPackageButtons() {
    document.querySelectorAll('[data-hrw-package-button]').forEach(button => {
      button.setAttribute('type', 'button');
      button.setAttribute('aria-pressed', button.classList.contains('active') ? 'true' : 'false');

      button.addEventListener('click', event => {
        event.preventDefault();

        const index = Number(button.dataset.packageIndex || 0);

        hasUserInteracted = true;

        const result = reactToCurrentInputs(index);

        latestScores = result.scores;
        latestPackageIndex = index;

        submitPackageFormAndRedirect(index);
      });
    });
  }

  function bindAnalyzeButton() {
    const widgetRoot = root();

    if (!widgetRoot) return;

    const analyzeButton = widgetRoot.querySelector('[data-hrw-analyze-button]');

    if (!analyzeButton) return;

    analyzeButton.addEventListener('click', async event => {
      event.preventDefault();

      hasUserInteracted = true;

      const result = await runAnalysis(false);

      submitPackageFormAndRedirect(result.packageIndex);
    });
  }

  function preventDisabledViewClicks() {
    document.querySelectorAll('[data-hrw-view-details]').forEach(button => {
      button.addEventListener('click', event => {
        const isDisabled =
          button.classList.contains('is-disabled') ||
          button.getAttribute('aria-disabled') === 'true';

        if (isDisabled) {
          event.preventDefault();
        }
      });
    });
  }

  function bindProductForms() {
    document.querySelectorAll('[data-hrw-rec-bar] form').forEach(form => {
      form.addEventListener('submit', () => {
        ensureCartPropertiesBeforeSubmit(form);
      });
    });
  }

  function bindMobilePopup() {
    const widgetRoot = root();

    if (!widgetRoot) return;

    const popup = widgetRoot.querySelector('[data-hrw-mobile-popup]');

    if (!popup) return;

    const closeButtons = popup.querySelectorAll('[data-hrw-mobile-popup-close]');
    const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

    let isClosed = false;

    const openPopup = () => {
      if (!isMobile()) return;
      if (isClosed) return;

      popup.hidden = false;
      document.body.classList.add('hrw-mobile-popup-open');
    };

    const closePopup = () => {
      isClosed = true;
      popup.hidden = true;
      document.body.classList.remove('hrw-mobile-popup-open');
    };

    closeButtons.forEach(button => {
      button.addEventListener('click', closePopup);
    });

    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !popup.hidden) {
        closePopup();
      }
    });

    window.addEventListener('resize', () => {
      if (!isMobile() && !popup.hidden) {
        popup.hidden = true;
        document.body.classList.remove('hrw-mobile-popup-open');
        return;
      }

      openPopup();
    });

    openPopup();
  }

  function bindEvents() {
    const widgetRoot = root();

    if (!widgetRoot) return;

    ensureNoneOptions();

    widgetRoot.querySelectorAll('input[type="checkbox"], input[type="radio"], select').forEach(input => {
      input.removeAttribute('data-hrw-touched');
      input.addEventListener('change', onInputChange);
    });

    syncAllExclusiveNoneGroups();

    bindMobilePopup();
    bindPaneNavigation();
    bindPackageButtons();
    bindAnalyzeButton();
    preventDisabledViewClicks();
    bindProductForms();
  }

  function init() {
    bindEvents();
    updateProfileCompletion();
    selectPackage(0, false);
    toggleRecommendationActions(0, false);
    clearCartPropertyInputs();
  }

  window.HRW = {
    runAnalysis,
    selectPackage,
    computeScores,
    recommend,
    getCartProperties,
    updateProfileCompletion,
    reactToCurrentInputs,
    submitPackageFormAndRedirect
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();